import React, { useEffect } from 'react'
import katiaDoodleToys from '../lettering/katia_doodle_toys.svg';
import '../styles/ShopHeader.css'
import { useLocation, useNavigate } from 'react-router-dom';

import otkritki from '../lettering/otkritki.svg'
import posteri from '../lettering/posteri.svg'
import kubiki from '../lettering/kubiki.svg'
import arhiv from '../lettering/arhiv.svg'
import nazad from '../icons/nazad.svg'
import gdekupit from '../lettering/gde_kupit.svg'

const ShopHeader = ({type}) => {
    const navigate = useNavigate()
    const location = useLocation()
    const goBack = (path) => {
        navigate('/')
    }
  return (
    <header className="ShopHeader">
        <img src={katiaDoodleToys} alt="Doodle Toys Orange" className="shopHeaderImg" />
        <div className="shopTypeBack">
            {/* <NavLink className={'shopGoBackLink'} to="/"> <img src={nazad} alt="Назад" className='shopGoBack' /> </NavLink> */}
            <img src={nazad} alt="Назад" className='shopGoBack' onClick={() => goBack()} />
            {type == 'cards' && <img src={otkritki} alt="Открытки" className='shopHeaderTypeCards'/> }
            {type == 'posters' && <img src={posteri} alt="Постеры" className='shopHeaderTypePosters'/> }
            {type == 'cubes' && <img src={kubiki} alt="Кубики и магниты" className='shopHeaderTypeCubes'/> }
            {type == 'archive' && <img src={arhiv} alt="Архив" className='shopHeaderTypeArchive'/> }
            {location.pathname == '/buy' && <img src={gdekupit} alt="Где купить" className='shopHeaderTypePosters'/> }
        </div>
    </header>
  )
}

export default ShopHeader